export class ClientConstants {
    public static readonly Currencies = [
        { value: 0, name: "EUR" },
        { value: 1, name: "RON" },
        { value: 2, name: "GBP" },
        { value: 3, name: "USD" }
    ]
}